import { useCallback, useState } from "react";
import { useDispatch } from "react-redux";
import { showError } from "../../../../redux/common/actions";
import { bulkPasteModelTaskQuestion } from "services/models/modelDetails/modelTasks";
import {
	getCopiedQuestionId,
	clearCopiedQuestionsClipboard,
} from "helpers/modelTaskClipboard";

/**
 * Pastes a single copied Question onto the whole selection in one request.
 *
 * Sibling to useBulkPasteQuestions, but for a single copied Question rather
 * than a whole Task's Question set.
 */
const useBulkPasteQuestion = ({ modelVersionId, onPasted }) => {
	const dispatch = useDispatch();
	const [isPasting, setIsPasting] = useState(false);

	const pasteQuestion = useCallback(
		async (taskIds) => {
			const sourceQuestionId = getCopiedQuestionId();
			if (!sourceQuestionId) return null;

			setIsPasting(true);
			try {
				const response = await bulkPasteModelTaskQuestion({
					modelVersionId,
					sourceQuestionId,
					taskIds,
				});
				if (!response?.status) {
					dispatch(
						showError(
							response?.data?.title ||
								response?.data ||
								"Could not paste the question onto the selected tasks"
						)
					);
					return null;
				}
				clearCopiedQuestionsClipboard();
				const skipped = response.data?.skippedIDs ?? [];
				if (skipped.length > 0) {
					dispatch(
						showError(`${skipped.length} of ${taskIds.length} were skipped`)
					);
				}
				await onPasted();
				return taskIds.filter((id) => !skipped.includes(id));
			} finally {
				setIsPasting(false);
			}
		},
		[dispatch, modelVersionId, onPasted]
	);

	return { pasteQuestion, isPasting };
};

export default useBulkPasteQuestion;
